import React from 'react';
import './Spinner.styles.scss';
import Loader from '../../assets/Logo/logo-small-blue.png';

const Spinner = () => {
	return (
		<>
			<div className="loading-wrapper">
				<div className="loading">
					<img src={Loader} alt="" />
				</div>
			</div>
		</>
	);
};

export default Spinner;
